import { render, staticRenderFns } from "./PresenceDialog.vue?vue&type=template&id=15645a4c"
import script from "./PresenceDialog.vue?vue&type=script&lang=js"
export * from "./PresenceDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports